import { BaseCard as QESummaryCard } from '../../common/BaseCard';
import { Button, CircularProgress } from '@material-ui/core';
import { QEScoreStatusCard } from './QEScoreStatus';
import { useStyles } from '../../styles';
import { AnalyzeIcon } from './AnalyzeIcon';
import { getNextDayDateString } from '../../utils/';
import { ANALYSIS_EXECUTION_STATUS } from '../../constants';
import { QeScoreAnalysisStatus } from '../../interfaces';

interface QEScoreSummaryCardProps {
  currentMonthWeight: number;
  maximumKpiWeightage: number;
  isLoading: boolean;
  isDisabled?: boolean;
  onAnalyzeClick: () => void;
  analysisDoneToday?: QeScoreAnalysisStatus;
  applicationName: string;
}

export function QEScoreSummaryCard({
  currentMonthWeight,
  maximumKpiWeightage,
  isLoading,
  isDisabled = false,
  onAnalyzeClick,
  analysisDoneToday,
  applicationName,
}: QEScoreSummaryCardProps) {
  const classes = useStyles();

  const nextAnalysisDate = getNextDayDateString(
    new Date().toISOString().split('T')[0],
  );

  const analysisHintMessage =
    analysisDoneToday === ANALYSIS_EXECUTION_STATUS.DONE
      ? `Analyze button will be enabled on ${nextAnalysisDate} (UTC)`
      : '';

  return (
    <QESummaryCard>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ">
        <QEScoreStatusCard
          currentMonthWeight={currentMonthWeight}
          maximumWeightLimit={maximumKpiWeightage}
          applicationName={applicationName}
        />

        <div className="flex flex-col items-end gap-2">
          {analysisHintMessage && (
            <span className={classes.analysisHintText}>
              {analysisHintMessage}
            </span>
          )}
          <Button
            variant="contained"
            color="primary"
            disabled={isDisabled}
            onClick={onAnalyzeClick}
            className="flex-shrink-0"
            classes={{
              root: classes.analysisButton,
              label: `${classes.flex} ${classes.gap1}`,
            }}
          >
            {isLoading ? (
              <>
                <CircularProgress size={16} color="inherit" />
                <span>Analysis is in progress...</span>
              </>
            ) : (
              <>
                <AnalyzeIcon
                  fontSize="large"
                  stroke={classes.analyzeButtonIcon}
                />
                <span>Analyze QE Score</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </QESummaryCard>
  );
}
